export default "__VITE_ASSET__W3W7CK41__"